import Vue from "vue";

export default {
  //envia un token o los cardDetails. si esta el token de la saved card entonces se llama al servicio /token de decidir con el token permanente de la tarjeta.
  createTempToken: async (gatewayPublicKey, token, cardDetails) => {
    try {
      let payload;
      //es una tarjeta ya existente
      if (token) {
        payload = {
          token: token,
          security_code: cardDetails.CVC
        };
      } else {
        payload = {
          card_number: cardDetails.cardNumber,
          card_expiration_month: cardDetails.expirationDate.substring(0, 2),
          card_expiration_year: cardDetails.expirationDate.substring(3), //FIX evitamos poner un end porque asi funciona tanto si el usuario ingresó el formato del año en YY o si el autocomplete ingresó el formato YYYY
          security_code: cardDetails.CVC,
          card_holder_name: cardDetails.cardName,
          card_holder_identification: {
            type: "",
            number: ""
          }
        };
      }
      //Ingreso los datos de la tarjeta en el tokenizador de decidir y valido que los datos de la tarjeta sean válidos
      Vue.prototype.$axiosDecidir.defaults.headers.common[
        "apikey"
      ] = gatewayPublicKey;
      const tokenResponse = await Vue.prototype.$axiosDecidir.post(
        "/tokens",
        payload
      );
      return tokenResponse;
    } catch (err) {
      console.log(err);
      const error = new Error();
      error.code = 500;
      error.message =
        "Hubo un error al validar los datos de la tarjeta. Por favor vuelva a intentar nuevamente.";
      if (err.isAxiosError) {
        if (err.response) {
          if (err.response.status) error.code = err.response.status;
          if (err.response.data)
            if (
              err.response.data.message &&
              err.response.data.code != "internal_server_error"
            )
              error.message = err.response.data.message;
        }
      } else if (err.statusCode) error.code = err.statusCode;

      console.log({ errorCode: error.code, message: error.message });
      throw error;
    }
  },
  getCardType(id) {
    const cardTypes = {
      "1": "Visa",
      "104": "MasterCard",
      "65": "American Express",
      "30": "ArgenCard",
      "50": "BBPS",
      "27": "Cabal",
      "63": "Cabal Prisma",
      "34": "CoopePlus",
      "62": "CrediGuia",
      "38": "Credimás",
      "8": "Diners Club",
      "60": "Distribution",
      "103": "Favacard",
      "54": "Grupar",
      "29": "Italcred",
      "42": "Nativa",
      "37": "Nexo",
      "55": "Patagonia 365",
      "52": "Qida",
      "44": "Tarjeta Carrefour / Cetelem",
      "43": "Tarjeta Cencosud",
      "56": "Tarjeta Club Día",
      "61": "Tarjeta La Anónima",
      "24": "Tarjeta Naranja",
      "39": "Tarjeta Nevada",
      "45": "Tarjeta PymeNacion",
      "23": "Tarjeta Shopping",
      "64": "Tarjeta SOL",
      "59": "Tuya",
      "31": "Visa [Débito]",
      "67": "Cabal [Débito]",
      "106": "Maestro",
      "105": "MasterCard [Débito]",
      "108": "Cabal [Débito]"
    };
    return cardTypes[id];
  },
  humanizeDecidirError(error) {
    let message;
    if (error.error_type && error.error_type == "invalid_request_error") {
      message = "Error de validación:";
      if (error.validation_errors) {
        error.validation_errors.forEach(element => {
          if (element.code == "invalid_param" && element.param == "card_number")
            message += `
              Número de tarjeta es inválido.`;
          else if (element.code == "invalid_param" && element.param == "bin")
            message += `
              El número de tarjeta no coincide con la tarjeta seleccionada.`;
          else if (element.code == "invalid_param" && element.param)
            message += `
              Dato Inválido: ${element.param}`;
          else
            message += `
            ${element.code}: ${element.param}`;
        });
      }
    } else if (error.error_type && error.error_type == "not_found_error") {
      message = `No se encontró la tarjeta.`;
      if (error.entity_name == "OperationResource")
        message = `Falló el proceso de validación de tarjeta.`;
    } else if (error.status && error.status == "rejected") {
      message = `Tarjeta Rechazada.`;
      if (error.status_details)
        if (error.status_details.error)
          if (error.status_details.error.reason)
            if (error.status_details.error.reason.description) {
              message += `
              Motivo: ${error.status_details.error.reason.description}
              Nro de Ticket: ${error.status_details.ticket}`;
            }
    } else {
      message = `Hubo un error al procesar la tarjeta: 
      ${JSON.stringify(error)}`;
    }
    return message;
  }
};
